export default (old_string, values) => values.reduce((new_string, { type, value }) => new_string.replace(`{${type}}`, value), old_string)